/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const CamelCaseReg = /[_.-](\w|$)/g;
const camelCase = (str) => str.replace(CamelCaseReg, (_, x) => x.toUpperCase());
const demcamelize = (str, sep = '_') => str
    .replace(/([a-z\d])([A-Z])/g, `$1${sep}$2`)
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, `$1${sep}$2`)
    .toLowerCase();
const toCamelCase = (obj) => {
    if (!obj || typeof obj !== 'object')
        return obj;
    if (Array.isArray(obj)) {
        return obj.map(item => toCamelCase(item));
    }
    return Object.keys(obj).reduce((acc, cur) => {
        const cameledKey = camelCase(cur);
        acc[cameledKey] = toCamelCase(obj[cur]);
        return acc;
    }, {});
};
const toDecamelCase = (obj) => {
    if (!obj || typeof obj !== 'object')
        return obj;
    if (Array.isArray(obj)) {
        return obj.map(item => toDecamelCase(item));
    }
    return Object.keys(obj).reduce((acc, cur) => {
        const decamelizedKey = demcamelize(cur);
        acc[decamelizedKey] = toDecamelCase(obj[cur]);
        return acc;
    }, {});
};
export { camelCase, demcamelize, toCamelCase, toDecamelCase };
